// ShareButtons.tsx
'use client';

import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TwitterShareButton,
	WhatsappIcon,
	WhatsappShareButton,
	XIcon
} from 'react-share';
import animationData from './animation.json';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

// Dinamizar la importación de Lottie
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const ShareButtons = () => {
	const [copied, setCopied] = useState(false);
	const copyRef = useRef<any>(null); // Puedes ajustar el tipo según sea necesario

	const path = usePathname();
	const url = `https://talleressantaclara.cl${path}`;

	useEffect(() => {
		if (copied) {
			copyRef.current?.goToAndPlay(0);
			navigator.clipboard.writeText(url);

			setTimeout(() => {
				setCopied(false);
			}, 2000);
		}
	}, [copied, url]);

	return (
		<div className="share-buttons">
			<span>Compártelo en:</span>
			<ul>
				<li>
					<FacebookShareButton url={url}>
						<FacebookIcon size={32} round />
					</FacebookShareButton>
				</li>
				<li>
					<TwitterShareButton url={url}>
						<XIcon size={32} round />
					</TwitterShareButton>
				</li>
				<li>
					<WhatsappShareButton url={url}>
						<WhatsappIcon size={32} round />
					</WhatsappShareButton>
				</li>
				<li>
					<LinkedinShareButton url={url}>
						<LinkedinIcon size={32} round />
					</LinkedinShareButton>
				</li>
				<li>
					<button className="copy-btn" onClick={() => setCopied(true)}>
						<Lottie lottieRef={copyRef} animationData={animationData} color="red" autoPlay={false} loop={false} />
						{/* <svg>
              <use href="/svgs/sprite.svg#copy"></use>
            </svg> */}
					</button>
				</li>
			</ul>
		</div>
	);
};
